import SlotMachine from './SlotMachine';
export default SlotMachine;
